<template>
  <Panel header="Record Proportion by Month">
    <template #icons>
      <ChartHeader
        :notes-count="notes.length"
        :annotations-count="annotations.length"
        @annotations-mode-toggled="toggleAnnotationsMode"
        @notes-mode-toggled="toggleNotesMode"
      />
    </template>

    <!--    <Chart-->
    <!--      v-if="store.getters.getData"-->
    <!--      :id="reportId"-->
    <!--      :chartSpec="specRecordProportionByMonth"-->
    <!--      :data="store.getters.getData.conceptData"-->
    <!--      :annotations-config="{-->
    <!--        chartSpec: specRecordProportionByMonthAnnotation,-->
    <!--        annotationsParentElement: 'g',-->
    <!--        brushParentElement: 'g g',-->
    <!--      }"-->
    <!--      :signal-listener="listeners.setSelectionAreaSignal"-->
    <!--      :annotations="annotations"-->
    <!--      :annotation-mode="annotationsMode"-->
    <!--    />-->
    <NotesPanel v-if="notesMode" :notes="notes" />
    <template #footer>
      <div class="flex flex-row gap-2">
        <ChartActionIcon
          v-if="store.getters.getQueryIndex"
          :icon="mdiCodeBraces"
          tooltip="View Export Query"
          @iconClicked="
            helpers.openNewTab(
              links.getSqlQueryLink(
                store.getters.getQueryIndex[route.params.domain.toUpperCase()]
                  .PREVALENCE_BY_MONTH[0]
              )
            )
          "
        />
      </div>
    </template>
  </Panel>
</template>

<script setup lang="ts">
import { Chart } from "@/widgets/chart";
import { links } from "@/shared/config/links";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { specRecordProportionByMonth } from "./specRecordProportionByMonth";
import { specRecordProportionByMonthAnnotation } from "./specRecordProportionByMonthAnnotation";
import ChartHeader from "@/widgets/chart/ui/ChartHeader.vue";
import NotesPanel from "@/widgets/notesPanel/ui/NotesPanel.vue";
import { helpers } from "@/shared/lib/mixins";
import ChartActionIcon from "@/entities/toggleIcon/ToggleIcon.vue";
import { mdiCodeBraces } from "@mdi/js";
import Panel from "primevue/panel";
import useAnnotations from "@/shared/lib/composables/useAnnotations";
import useAnnotationControls from "@/shared/lib/composables/useAnnotationControls";

const store = useStore();
const route = useRoute();

const reportId = "viz-sourcerecordproportionbymonth";

const { notesMode, annotationsMode, toggleNotesMode, toggleAnnotationsMode } =
  useAnnotationControls();

const { annotations, notes } = useAnnotations(reportId);
</script>

<style scoped></style>
